import axios from 'axios';

export function findClasses(text) {
    return axios({
        method: 'post',
        url: '/api/v1/register-class/find',
        data: {
            query: text,
        },
        withCredentials: true,
    });
}

export function addClass(text) {
    return axios({
        method: 'post',
        url: '/api/vi/register-class/save',
        data: {
            query: text,
        },
        withCredentials: true,
    });
}

export function getClassById() {
    return axios({
        method: 'get',
        url: '/api/v1/register-class',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/registerClass.js